import React, { useState, useEffect } from 'react';

import Main from '../assets/images/main.png';
import Dakventilatie from '../assets/svg/dakvent.svg';
import WTW from '../assets/svg/wtwsysteem.svg';
import MechanischeVentilatie from '../assets/svg/ventilatie.svg';
import Result from '../assets/images/result.png';

import '../styles/landing.scss';

const Landing = () => {
  const [currentText, setCurrentText] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);
  const [textIndex, setTextIndex] = useState(0);
  
  useEffect(() => {
    document.title = 'Fresh Air Care';
  }, []);

  useEffect(() => {
    const texts = ['Gezond Leven.', 'Optimale Ventilatie.'];
    const typeSpeed = 100;
    const deleteSpeed = 50;
    const pauseTime = 2000;
    
    const timeout = setTimeout(() => {
      const current = texts[textIndex];
      
      if (!isDeleting) {
        if (currentText.length < current.length) {
          setCurrentText(current.substring(0, currentText.length + 1));
        } else {
          setTimeout(() => setIsDeleting(true), pauseTime);
        }
      } else {
        if (currentText.length > 0) {
          setCurrentText(currentText.substring(0, currentText.length - 1));
        } else {
          setIsDeleting(false);
          setTextIndex((textIndex + 1) % texts.length);
        }
      }
    }, isDeleting ? deleteSpeed : typeSpeed);
    
    return () => clearTimeout(timeout);
  }, [currentText, isDeleting, textIndex]);

  return (
     <div className="parent-landing">
         <div className="landing">
             <img src={Main} alt="Ventilatie installatie" className="landing-image"/>
             <div className="landing-overlay">
                 <div className="landing-content">
                 <div className="hero-section">
                    <h1 className="hero-title">
                    Frisse Lucht, <span className="typing-text">{currentText}</span>
                    </h1>
                     <p className="hero-description">
                         Professionele ventilatie-oplossingen voor uw woning en bedrijf.
                     Van mechanische ventilatie tot WTW-systemen en dakventilatie, 
                     wij zorgen voor optimale luchtkwaliteit en energiebesparing. 
                     </p>
                     <div className="cta-buttons">
                     <a href="/Contact" className="cta-primary" onClick={() => window.location.href = '/Contact'}>
                         Gratis Advies Aanvragen
                     </a>
                     <a href="/Tarieven" className="cta-secondary" onClick={() => window.location.href = '/Tarieven'}>
                         Bekijk Onze Tarieven
                     </a>
                     </div>
                 </div>
                 </div>
             </div>
         </div>
         
         <div className="services-section">
             <div className="services-container">
                <div className="services-kopjes">
                    <h2 className="services-title">Onze Services</h2>
                    <p className="services-description">Gezonde lucht, minder vocht en lager verbruik: 
                        <br /> kies de service die bij jouw situatie past.</p>
                </div>
                 <div className="services-grid">
                     <div className="service-card">
                         <div className="service-icon">
                            <img src={MechanischeVentilatie} alt="Mechanische Ventilatie img" />
                         </div>
                         <h3 className="service-title">Mechanische Ventilatie</h3>
                         <p className="service-description">
                         Constante, stille ventilatie met professionele installatie en onderhoud.
                         </p>
                         <a href="/Mechanische-ventilatie" className="service-button" onClick={() => window.location.href = '/Mechanische-ventilatie'}>
                             Meer Informatie
                         </a>
                     </div>

                     <div className="service-card">
                         <div className="service-icon">
                            <img src={WTW} alt="WTW Systemen" />
                         </div>
                         <h3 className="service-title">WTW Systemen</h3>
                         <p className="service-description">
                         Balansventilatie met warmteterugwinning voor frisse, gezonde lucht, altijd in gebruik.
                         </p>
                         <a href="/WTW-systemen" className="service-button" onClick={() => window.location.href = '/WTW-systemen'}>
                             Meer Informatie
                         </a>
                     </div>

                     <div className="service-card">
                         <div className="service-icon">
                            <img src={Dakventilatie} alt="Dakventilatie" />
                         </div>
                         <h3 className="service-title">Dakventilatie</h3>
                         <p className="service-description">
                         Effectieve dakventilatie en kanalen voor vochtbeheersing en doorstroom.
                         </p>
                         <a href="/Dakventilatie" className="service-button" onClick={() => window.location.href = '/Dakventilatie'}>
                             Meer Informatie
                         </a>
                     </div>
                 </div>
                 
                 <div className="projects-cta-section">
                     <div className="projects-cta-content">
                         <h3 className="projects-cta-title">Op zoek naar een maatwerk oplossing?</h3>
                         <p className="projects-cta-description">
                             Bekijk onze gerealiseerde projecten en ontdek hoe wij uw ventilatie-uitdaging kunnen oplossen.
                         </p>
                         <a href="/Tarieven" className="projects-cta-button" onClick={() => window.location.href = '/Tarieven'}>
                             <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                 <path d="M3 10H17M17 10L11 4M17 10L11 16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                             </svg>
                             Bekijk Onze Tarieven
                         </a>
                     </div>
                 </div>
             </div>
             
             <div className="help-section">
                 <div className="help-container">
                     <h2 className="help-title">Waarmee kunnen we helpen?</h2>
                     <p className="help-description">Kies je categorie en regel in 1 minuut inspectie, onderhoud of vervanging.</p>
                 </div>
             </div>
         </div>

         <div className="before-after">
            <div className="before-after-content">
                <div className="before-after-left">
                    <div className="before-after-text">
                        <h2 className="before-after-title">
                            <span className="highlight">Professionele resultaten</span> die spreken voor zich
                        </h2>
                        <p className="before-after-description">
                            Bekijk hoe wij uw ventilatie-uitdaging kunnen oplossen met bewezen resultaten en tevreden klanten.
                        </p>
                        <a className="before-after-cta" onClick={() => window.location.href = '/Tarieven'} href="/Tarieven">
                            Bekijk Tarieven
                        </a>
                    </div>
                    <div className="before-after-cards desktop-cards">
                        <div className="result-card">
                            <div className="result-number">Vaste prijs</div>
                            <div className="result-label">Geen onverwachte kosten</div>
                        </div>
                        <div className="result-card">
                            <div className="result-number">Snelle planning</div>
                            <div className="result-label">Reactie binnen 24 uur</div>
                        </div>
                        <div className="result-card">
                            <div className="result-number">Resultaatfoto's</div>
                            <div className="result-label">Direct te zien</div>
                        </div>
                        <div className="result-card">
                            <div className="result-number">Netjes & veilig</div>
                            <div className="result-label">Afdekken en stofarm werken</div>
                        </div>
                    </div>
                </div>
                <div className="before-after-right">
                    <div className="before-after-images">
                        <img src={Result} alt="Resultaat foto" />
                    </div>
                </div>
                <div className="before-after-cards mobile-cards">
                    <div className="result-card">
                        <div className="result-number">Vaste prijs</div>
                        <div className="result-label">Geen onverwachte kosten</div>
                    </div>
                    <div className="result-card">
                        <div className="result-number">Snelle planning</div>
                        <div className="result-label">Reactie binnen 24 uur</div>
                    </div>
                    <div className="result-card">
                        <div className="result-number">Resultaatfoto's</div>
                        <div className="result-label">Direct te zien</div>
                    </div>
                    <div className="result-card">
                        <div className="result-number">Netjes & veilig</div>
                        <div className="result-label">Afdekken en stofarm werken</div>
                    </div>
                </div>
            </div>
         </div>

         <div className="appointment-section">
            <div className="appointment-container">
                <div className="appointment-content">
                    <div className="appointment-left">
                        <h2 className="appointment-title">Maak nu je afspraak</h2>
                        <p className="appointment-description">
                            Klaar voor een gezondere leefomgeving? Plan vandaag nog een gratis 
                            inspectie in en ontdek hoe wij uw ventilatie kunnen verbeteren. 
                            Geen verplichtingen, alleen professioneel advies.
                        </p>
                        <a href="/Contact   " className="appointment-cta" onClick={() => window.location.href = '/Contact'}>
                            Gratis Inspectie Aanvragen
                        </a>
                    </div>
                    <div className="appointment-right">
                        <div className="appointment-features">
                            <div className="feature-item">
                                <div className="feature-icon">✓</div>
                                <span>Gratis inspectie</span>
                            </div>
                            <div className="feature-item">
                                <div className="feature-icon">✓</div>
                                <span>Geen verplichtingen</span>
                            </div>
                            <div className="feature-item">
                                <div className="feature-icon">✓</div>
                                <span>Professioneel advies</span>
                            </div>
                            <div className="feature-item">
                                <div className="feature-icon">✓</div>
                                <span>Snelle planning</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
         </div>
      </div>

  );
};

export default Landing;